// ************ ==== >>>> Page <<<< ==== ************//
import Login from "../pages/website/Login";
import Forgotpassword from "../pages/website/Forgotpassword.jsx";
import Resetpassword from "../pages/website/Resetpassword.jsx";

// ************ ==== >>>> Testing Components <<<< ==== ************//

import Dashboardnavbarcopy from "../layout/Dashboardnavbarcopy.jsx";


import Calander from "../components/dashboard-comp/Calaneder.jsx";
import Informationcomponent from "../components/dashboard-comp/Informationcomponent.jsx";


import Accountdashboard from "../pages/Accountdashboard/Accountdashboard.jsx";


// ************ ==== >>>> Components <<<< ==== ************//
import Userdetailsmain from "../components/UserDetails/Userdetailsmain.jsx";
import Userdetailscrud from "../components/UserDetails/UserDetailsPermission_role.jsx";

// ************ ==== >>>> Interview Form <<<< ==== ************//

import UserDetails from "../components/UserDetails/UserDetails.jsx";

import { ApplicantviewRound1, ApplicantviewRound2, ApplicantviewRound3, ApplicantviewRound4, Applicantview, AppliedPage } from "../components/career/update_details/ApplicantviewRounds.jsx";



import Workforcemangement from "../components/workforcemanagement/Workforcemangement.jsx";
import TlWorkfm from "../components/workforcemanagement/TlWorkfm.jsx";




// ************ ==== >>>> Employee Dashboard <<<< ==== ************//
import SiteManagementDashboard from "../pages/sitedashboard/SiteDashboard.jsx";
import SiteDashboard from "../pages/sitedashboard/Main/dashboard.jsx";


// ************ ==== >>>> Employee Dashboard <<<< ==== ************//
import EmployeeDashboard from "../pages/employeedashboard/Employeedashboard.jsx";
import EmpDashboard from "../pages/employeedashboard/Main/Dashboard.jsx";

// ************ ==== >>>> Tl Dashboard <<<< ==== ************//
import TlDashboardd from "../pages/teamleaddashboard/TlDashboard.jsx";
import TlDashboard from "../pages/teamleaddashboard/Main/dashboard";

// ************ ==== >>>> Hod Dashboard <<<< ==== ************//
import HodDashboardd from "../pages/hoddashboard/HodDashboard";
import HodDashboard from "../pages/hoddashboard/Main/dashboard";
import HOD from "../components/workforcemanagement/HOD.jsx";

// ************ ==== >>>> Career Dashboard <<<< ==== ************//
import CareerDashboardContainer from "../pages/careerdashboard/CareerDashboard.jsx";

import CareerDashboardComponent from "../pages/careerdashboard/Main/dashboard.jsx";

// ************ ==== >>>> Hr Dashboard <<<< ==== ************//
import HrDashboardd from "../pages/hrdashboard/HrDashboard";

import HrDashboard from "../pages/hrdashboard/Main/dashboard";

// ************ ==== >>>> Admin Dashboard <<<< ==== ************//
import AdminDashboardd from "../pages/admindashboard/AdminDashboard";
import AdminDashboard from "../pages/admindashboard/Main/dashboard.jsx";
import Career from "../components/career/CareerDisplay.jsx";

// ************ ==== >>>> IT Dashboard <<<< ==== ************//
import ItDashboardMain from "../pages/ITdashboard/IT_Dashboard.jsx";
import ItDashboard from "../pages/ITdashboard/Main/Dashboard.jsx";

import PerformanceManagement from "../components/workforcemanagement/PerformanceManagement.jsx";
import Settingsit from "../components/settings/Settingit.jsx";
import Letter3 from "../components/LetterHead/Letter3.jsx";

import Letter1 from "../components/LetterHead/Letter1.jsx";
import Letter2 from "../components/LetterHead/Letter2.jsx";
import Letter from "../components/LetterHead/Letter.jsx";
import Letter4 from "../components/LetterHead/Letter4.jsx";

import PayrollManagement from "../components/PayrollManagement/PayrollManagement.jsx";
import RequisitionManagement from "../components/RequisitionManagement/RequisitionManagement.jsx";
import { CompletePage, PersonaldetailsAccountdetails, PersonaldetailsDocumentdetails, PersonaldetailsEducationdetails, PersonaldetailsEmergencycontactdetails, PersonaldetailsProfile, Personaldetailsworkexprience } from "../components/career/PersonaldetailsProfile.jsx";
import { DocumentdetailsPage, EducationDetail, Personaldetails, Positiondetails, Workexprience } from "../components/career/PersonaldetailsCareer.jsx";
import StationaryManagement from "../components/StationaryManagement/StationaryManagement.jsx";
import SiteManagement from "../components/SiteManagement/SiteManagement.jsx";
import WebsiteManagement from "../components/WebsiteManagement/WebsiteManagement.jsx";
import { ProjectAllDetails, ProjectConsultantDetails, ProjectContractorDetails, SiteProjectBillDetails } from "../components/SiteManagement/SiteProjectManagement.jsx";
import ImprestExpenseManagement from "../components/ImprestExpenseManagement/ImprestExpenseManagement.jsx";
import ExpenseSlipByExpense from "../components/ImprestExpenseManagement/ExpenseSheet/ExpenseSlipByExpense.jsx";
import ExpenseSlipByRequest from "../components/ImprestExpenseManagement/ExpenseSheet/ExpenseSlipByRequest.jsx";
import { AccountsImprestExpenseRequestMangement } from "../components/ImprestExpenseManagement/ImprestExpenseRequestManagement.jsx";
import AdminMenu from "../pages/admindashboard/AdminMenu.jsx";
import TicketsManagement from "../components/TicketsManagement/TicketsManagement.jsx";
import { ViewTicket } from "../components/TicketsManagement/TicketsTables.jsx";
import PrintDynamicUpcomingSalarySlip from "../components/salryslip/SalarySlipDynamicIncoming.jsx";
import { AccountsRequestMangement, AdminRequestsManagementTab, HODRequestsManagementTab, HRRequestsManagementTab, TeamRequestsManagementTab } from "../components/EmployeeManagement/RequestManagementDisplay.jsx";
import { SeprationHeadingAuthorityViewPage } from "../components/SeprationManagement/SeprationTables.jsx";
import CalenderContextprovider from "../components/Meetingscheduler/ContextProvider.js";
import { BDEmployeeDataView } from "../components/workforcemanagement/EmployeeDataExcel.jsx";
import SettingsManagementDisplay from "../components/settings/SettingsManagementDisplay.jsx";
import HRActivitiesManagement from "../components/settings/HRActivities/HRActivitiesDisplay.jsx";
import CriticalTaskManagement from "../components/CriticalTasksManagement/TasksManagement.jsx";
import ReportsManagement from "../components/ReportsManagement/ReportsManagement.jsx";
import EmployeeLetterView from "../components/DynamicBuilders/LetterBuilderManagement/EmployeeLetterViewPage.jsx";
import { DynamicRequestsManagementTab } from "../components/settings/DynamicApprovalProcess/DynamicApprovalDisplay.jsx";
import DynamicExpenseSlip from "../components/ImprestExpenseManagement/ExpenseSheet/DynamicExpenseSlip.jsx";
import DynamicSalarySlip from "../components/salryslip/DynamicSalarySlip.jsx"
import { AttendanceAndSelfRequestManagement } from "../components/EmployeeManagement/EmployeeManagementDisplay.jsx";
import { CareerApplyLandingPage, JobApplyLanding } from "../components/career/JobPostingComponents.jsx";
import EmployeeLetterViewPR from "../components/DynamicBuilders/LetterBuilderManagement/EmployeeLetterViewPage.jsx";
import DataSalarySlip from "../components/salryslip/SalarySlipDynamicIncoming.jsx";
import CurrentSalarySlip from "../components/salryslip/SalarySlipDynamicIncoming.jsx";
import SavedSalarySlip from "../components/salryslip/SalarySlipDynamic.jsx";
import PrintDynamicSalarySlipData from "../components/salryslip/SalarySlipDynamic.jsx";
import { components } from "react-select";
import ExpenseSlip from "../components/ImprestExpenseManagement/ExpenseSheet/ExpenseSlipByExpense.jsx";
import ProjectDetailsManagement from "../components/ProjectDetails/ProjectDetailsManagement.jsx";
import HelpDeskDisplay from "../components/HelpDesk/HelpDeskDisplay.jsx";


export const routingData = [
  {
    role: "",
    isProtected: false,
    defaultRoute: "/",
    routes: [
      {
        path: "",
        component: <Login />,
      },

      {
        path: "login",
        component: <Login />,
      },
      {
        path: "forgotpassword/",
        component: <Forgotpassword />,
      },
      {
        path: "resetpassword/:uidb64/:token/",
        component: <Resetpassword />,
      },

      {
        path: "calander",
        component: <Calander />,
      },
      {
        path: "informationcomponent",
        component: <Informationcomponent />,
      },
      {
        path: "dashboardnavbarcopy",
        component: <Dashboardnavbarcopy />,
      },

      {
        path: ":company_id/:company/job-apply/",
        // component: <JobApplyLanding />,
        component: <CareerApplyLandingPage />,
      },

      {
        path: "personaldetails/:id/",
        component: <Personaldetails />,
      },
      {
        path: "personaldetails/:id/:email/",
        component: <Personaldetails />,
      },
      {
        path: "positiondetails/:id/:email/",
        component: <Positiondetails />,
      },
      {
        path: "educationdetail/:id/:email/",
        component: <EducationDetail />,
      },

      {
        path: "workexprience/:id/:email/",
        component: <Workexprience />,
      },
      {
        path: "document/:id/:email/",
        component: <DocumentdetailsPage />,
      },
      {
        path: "jobApplied/",
        component: <AppliedPage />,
      },
      {
        path: "processComplete/",
        component: <CompletePage />,
      },

      {
        path: "applicantview/:id/:email/",
        component: <Applicantview />,
      },
      {
        path: "applicantview/round1/:id/:email/",
        component: <ApplicantviewRound1 />,
      },
      {
        path: "applicantview/round2/:id/:email/",
        component: <ApplicantviewRound2 />,
      },
      {
        path: "applicantview/round3/:id/:email/",
        component: <ApplicantviewRound3 />,
      },
      {
        path: "applicantview/round4/:id/:email/",
        component: <ApplicantviewRound4 />,
      },

      {
        path: "letter3",
        component: <Letter3 />,
      },
      {
        path: "letter1",
        component: <Letter1 />,
      },
      {
        path: "letter2",
        component: <Letter2 />,
      },
      {
        path: "letter4",
        component: <Letter4 />,
      },
      {
        path: "requestExpenseSlip/:id/",
        // component: <DynamicExpenseSlip mode="request" />,
        component: <ExpenseSlipByRequest />,
      },

      {
        path: "dynamicSalarySlip",
        component: <PrintDynamicSalarySlipData />,
        // component: <DynamicSalarySlip mode="monthly" />
        // component: <SavedSalarySlip />
      },
      {
        path: "upcomingSalarySlip",
        component: <PrintDynamicUpcomingSalarySlip />,
        // component: <CurrentSalarySlip />
        // component: <DynamicSalarySlip mode ="upcoming" />
      },

      {
        path: "seprationAuthorityRemarks/:id/:emp_code/:position/",
        component: <SeprationHeadingAuthorityViewPage />,
      },
      {
        path: "employeeLetterView/:id/",
        component: <EmployeeLetterViewPR />,
      }
    ],
  },
  {
    role: "",
    isProtected: false,
    defaultRoute: "jd/jdmain",
    nestedRoutes: [
      {
        routes: [
          {
            path: "userdetails",
            component: <Userdetailsmain />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "educationDetailss/:email/",
            component: <PersonaldetailsEducationdetails />,
          },
          {
            path: "workexperiencee/:email/",
            component: <Personaldetailsworkexprience />,
          },
          {
            path: "emergencycontacts/:email/",
            component: <PersonaldetailsEmergencycontactdetails />,
          },
          // {
          //   path: "accountdetailss/:email/",
          //   component: <PersonaldetailsAccountdetails />,
          // },
          {
            path: "documentdetailss/:email/",
            component: <PersonaldetailsDocumentdetails />,
          },


          {
            path: "userdetail",
            component: <UserDetails />,
          },

          {
            path: "userdetail/letter3",
            component: <Letter3 />,
          },
          {
            path: "userdetail/letter1",
            component: <Letter1 />,
          },
          {
            path: "userdetail/letter2",
            component: <Letter2 />,
          },
          {
            path: "letter4",
            component: <Letter4 />,
          },
        ],
        // path: "jd",
        // component: <Jobapplicantdashboardd />,
      },
    ],
  },

  {
    role: "SiteManagement",
    isProtected: true,
    defaultRoute: "site/siteDashboard",
    nestedRoutes: [
      {
        routes: [
          {
            path: "",
            component: <SiteDashboard />,
          },
          {
            path: "siteDashboard",
            component: <SiteDashboard />,
          },

          {
            path: "criticalIssues",
            component: <CriticalTaskManagement />,
          },


          {
            path: "userdetail",
            component: <UserDetails />,
          },

          {
            path: "empDashboard/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetail/letterhead",
            component: <Letter />,
          },
          {
            path: "expenseSlip",
            // component: <DynamicExpenseSlip mode="expense" />,
            component: <ExpenseSlipByExpense />,
            // component: <ExpenseSlip />     
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },

          {
            path: "siteManagement",
            component: < SiteManagement />,
          },

          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "site",
        component: <SiteManagementDashboard />,
      },
    ],
  },

  {
    role: "Employee",
    isProtected: true,
    defaultRoute: "ed/empDashboard",
    nestedRoutes: [
      {
        routes: [
          {
            path: "",
            component: <EmpDashboard />,
          },
          {
            path: "empDashboard",
            component: <EmpDashboard />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "attendanceAndRequest",
            component: <AttendanceAndSelfRequestManagement />,
          },
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "dynamicRequestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "criticalIssues",
            component: <CriticalTaskManagement />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "empDashboard/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetail/letterhead",
            component: <Letter />,
          },

          {
            path: "expenseSlip",
            // component: <DynamicExpenseSlip mode="expense" />,
            component: <ExpenseSlipByExpense />,
            // component: <ExpenseSlip />
          },
          {
            path: "requestExpenseSlip/:id/",
            // component: <DynamicExpenseSlip mode="request" />,
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "dynamicSalarySlip",
            component: <PrintDynamicSalarySlipData />,
            // component: <DynamicSalarySlip mode ="monthly" />
            // component: <SavedSalarySlip />
          },
          {
            path: "employeeDetails/",
            component: <BDEmployeeDataView />,
          },
          
          {
            path: "projectDetails",
            component: <ProjectDetailsManagement />
          },
          {
            path: "helpDesk",
            component: <HelpDeskDisplay />
          },
        ],
        path: "ed",
        component: <EmployeeDashboard />,
      },
    ],
  },

  {
    role: "ReportingHead",
    isProtected: true,
    defaultRoute: "tl/tlDashboard",
    nestedRoutes: [
      {
        routes: [
          {
            path: "",
            component: <TlDashboard />,
          },
          {
            path: "tlDashboard",
            component: <TlDashboard />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "attendanceAndRequest",
            component: <AttendanceAndSelfRequestManagement />,
          },
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "wfm",
            component: <TlWorkfm />,
          },
          {
            path: "teamRequestManagement",
            component: <TeamRequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "dynamicRequestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "userdetailscrud/:emp_code/:email/",
            component: <Userdetailscrud />,
          },
          {
            path: "criticalIssues",
            component: <CriticalTaskManagement />,
          },

          {
            path: "tlDashboard/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetail/letterhead",
            component: <Letter />,
          },

          {
            path: "RequisitionManagement",
            component: <RequisitionManagement />,
          },
          {
            path: "expenseSlip",
            // component: <DynamicExpenseSlip mode="expense" />,
            component: <ExpenseSlipByExpense />,
            // component: <ExpenseSlip />
          },
          {
            path: "requestExpenseSlip/:id/",
            // component: <DynamicExpenseSlip mode="request" />,
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "dynamicSalarySlip",
            component: <PrintDynamicSalarySlipData />,
            // component: <DynamicSalarySlip mode ="monthly" />
            // component: <SavedSalarySlip />
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "employeeDetails/",
            component: <BDEmployeeDataView />,
          },
          
          {
            path: "projectDetails",
            component: <ProjectDetailsManagement />
          },
          {
            path: "helpDesk",
            component: <HelpDeskDisplay />
          },
        ],
        path: "tl",
        component: <TlDashboardd />,
      },
    ],
  },

  {
    role: "Account",
    isProtected: true,
    defaultRoute: "acc/account",
    nestedRoutes: [
      {
        routes: [
          {
            path: "",
            component: <EmpDashboard />,
          },
          {
            path: "account",
            component: <EmpDashboard />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "attendanceAndRequest",
            component: <AttendanceAndSelfRequestManagement />,
          },
          {
            path: "teamRequestManagement",
            component: <TeamRequestsManagementTab />,
          },
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "dynamicRequestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "criticalIssues",
            component: <CriticalTaskManagement />,
          },
          {
            path: "imprestExpenseRequestManagement",
            component: <AccountsImprestExpenseRequestMangement />,
          },
          {
            path: "accountsRequestsManagement",
            component: <AccountsRequestMangement />,
          },

          {
            path: "empDashboard/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetail/letterhead",
            component: <Letter />,
          },
          {
            path: "expenseSlip",
            // component: <DynamicExpenseSlip mode="expense" />,
            component: <ExpenseSlipByExpense />,
            // component: <ExpenseSlip />
          },
          {
            path: "requestExpenseSlip/:id/",
            // component: <DynamicExpenseSlip mode="request" />,
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "dynamicSalarySlip",
            component: <PrintDynamicSalarySlipData />,
            // component: <DynamicSalarySlip mode ="monthly" />
            // component: <SavedSalarySlip />
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "customReports",
            component: <ReportsManagement />
          },
          
          {
            path: "projectDetails",
            component: <ProjectDetailsManagement />
          },
          {
            path: "helpDesk",
            component: <HelpDeskDisplay />
          },
        ],
        path: "acc",
        component: <Accountdashboard />,
      },
    ],
  },

  {
    role: "IT",
    isProtected: true,
    defaultRoute: "it/itDashboard",
    nestedRoutes: [
      {
        routes: [
          {
            path: "",
            component: <ItDashboard />,
          },
          {
            path: "itDashboard",
            component: <ItDashboard />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "teamRequestManagement",
            component: <TeamRequestsManagementTab />,
          },
          {
            path: "attendanceAndRequest",
            component: <AttendanceAndSelfRequestManagement />,
          },
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "dynamicRequestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "setting",
            component: <Settingsit />,
          },
          {
            path: "criticalIssues",
            component: <CriticalTaskManagement />,
          },

          {
            path: "itDashboard/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetail/letterhead",
            component: <Letter />,
          },
          {
            path: "expenseSlip",
            // component: <DynamicExpenseSlip mode="expense" />,
            component: <ExpenseSlipByExpense />,
            // component: <ExpenseSlip />
          },
          {
            path: "requestExpenseSlip/:id/",
            // component: <DynamicExpenseSlip mode="request" />,
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "dynamicSalarySlip",
            component: <PrintDynamicSalarySlipData />,
            // component: <DynamicSalarySlip mode ="monthly" />
            // component: <SavedSalarySlip />
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "helpDesk",
            component: <HelpDeskDisplay />
          },
        ],
        path: "it",
        component: <ItDashboardMain />,
      },
    ],
  },


  {
    role: "HOD",
    isProtected: true,
    defaultRoute: "hod/hodDashboard",
    nestedRoutes: [
      {
        routes: [
          {
            path: "",
            component: <HodDashboard />,
          },
          {
            path: "hodDashboard",
            component: <HodDashboard />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "attendanceAndRequest",
            component: <AttendanceAndSelfRequestManagement />,
          },
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "wfm",
            component: <HOD />,
          },
          {
            path: "teamRequestManagement",
            component: <TeamRequestsManagementTab />,
          },
          {
            path: "hodRequestManagement",
            component: <HODRequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "dynamicRequestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "criticalIssues",
            component: <CriticalTaskManagement />,
          },
          //
          {
            path: "userdetailscrud/:emp_code/:email/",
            component: <Userdetailscrud />,
          },
          {
            path: "hodDashboard/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetail/letterhead",
            component: <Letter />,
          },

          {
            path: "RequisitionManagement",
            component: <RequisitionManagement />,
          },
          {
            path: "expenseSlip",
            // component: <DynamicExpenseSlip mode="expense" />,
            component: <ExpenseSlipByExpense />,
            // component: <ExpenseSlip />
          },
          {
            path: "dynamicSalarySlip",
            component: <PrintDynamicSalarySlipData />,
            // component: <DynamicSalarySlip mode ="monthly" />
            // component: <SavedSalarySlip />
          },
          {
            path: "requestExpenseSlip/:id/",
            // component: <DynamicExpenseSlip mode="request" />,
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          
          {
            path: "projectDetails",
            component: <ProjectDetailsManagement />
          },
          {
            path: "helpDesk",
            component: <HelpDeskDisplay />
          },
        ],
        path: "hod",
        component: <HodDashboardd />,
      },
    ],
  },
  {
    role: "Career",
    isProtected: true,
    defaultRoute: "career/careerDashboard",
    nestedRoutes: [
      {
        routes: [
          {
            path: "",
            component: <CareerDashboardComponent />,
          },
          {
            path: "careerDashboard",
            component: <CareerDashboardComponent />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "attendanceAndRequest",
            component: <AttendanceAndSelfRequestManagement />,
          },
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "criticalIssues",
            component: <CriticalTaskManagement />,
          },
          {
            path: "teamRequestManagement",
            component: <TeamRequestsManagementTab />,
          },
          {
            path: "hrRequestManagement",
            component: <HRRequestsManagementTab />,
          },
          {
            path: "dynamicRequestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "wfm",
            component: <TlWorkfm />,
          },

          {
            path: "career",
            component: <Career />,
          },
          {
            path: "performancemanagement",
            component: <PerformanceManagement />,
          },
          {
            path: "payrollmanagement",
            component: <PayrollManagement />,
          },
          {
            path: "stationaryManagement",
            component: <StationaryManagement />,
          },
          {
            path: "setting",
            component: <SettingsManagementDisplay />,
          },

          {
            path: "hractivities",
            component: <HRActivitiesManagement />,
          },

          {
            path: "userdetailscrud/:emp_code/:email/",
            component: <Userdetailscrud />,
          },

          {
            path: "careerDashboard/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetail/letterhead",
            component: <Letter />,
          },

          {
            path: "userdetailscrud/:emp_code/:email/letterhead",
            component: <Letter />,
          },

          {
            path: "expenseSlip",
            // component: <DynamicExpenseSlip mode="expense" />,
            component: <ExpenseSlipByExpense />,
          },

          {
            path: "requestExpenseSlip/:id/",
            // component: <DynamicExpenseSlip mode="request" />,
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "dynamicSalarySlip",
            // component: <SavedSalarySlip />
             component: <PrintDynamicSalarySlipData />
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },

          {
            path: "educationDetailss/:email/",
            component: <PersonaldetailsEducationdetails />,
          },

          {
            path: "workexperiencee/:email/",
            component: <Personaldetailsworkexprience />,
          },

          {
            path: "emergencycontacts/:email/",
            component: <PersonaldetailsEmergencycontactdetails />,
          },

          {
            path: "documentdetailss/:email/",
            component: <PersonaldetailsDocumentdetails />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "employeeDetails/",
            component: <BDEmployeeDataView />,
          },

        ],
        path: "career",
        component: <CareerDashboardContainer />,
      },
    ],
  },

  {
    role: "HR",
    isProtected: true,
    defaultRoute: "hr/hrDashboard",
    nestedRoutes: [
      {
        routes: [
          {
            path: "",
            component: <HrDashboard />,
          },
          {
            path: "hrDashboard",
            component: <HrDashboard />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "attendanceAndRequest",
            component: <AttendanceAndSelfRequestManagement />,
          },
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "criticalIssues",
            component: <CriticalTaskManagement />,
          },
          {
            path: "teamRequestManagement",
            component: <TeamRequestsManagementTab />,
          },
          {
            path: "hrRequestManagement",
            component: <HRRequestsManagementTab />,
          },
          {
            path: "dynamicRequestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "wfm",
            component: <Workforcemangement />,
          },

          {
            path: "career",
            component: <Career />,
          },
          {
            path: "performancemanagement",
            component: <PerformanceManagement />,
          },
          {
            path: "payrollmanagement",
            component: <PayrollManagement />,
          },
          {
            path: "stationaryManagement",
            component: <StationaryManagement />,
          },
          {
            path: "setting",
            component: <SettingsManagementDisplay />,
          },

          {
            path: "hractivities",
            component: <HRActivitiesManagement />,
          },


          {
            path: "userdetailscrud/:emp_code/:email/",
            component: <Userdetailscrud />,
          },

          {
            path: "hrDashboard/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetail/letterhead",
            component: <Letter />,
          },

          {
            path: "userdetailscrud/:emp_code/:email/letterhead",
            component: <Letter />,
          },


          // {
          //   path: "RequisitionManagement",
          //   component: <RequisitionManagement/>
          // },

          {
            path: "expenseSlip",
            // component: <DynamicExpenseSlip mode="expense" />,
            component: <ExpenseSlipByExpense />,
            // component: <ExpenseSlip />
          },

          {
            path: "requestExpenseSlip/:id/",
            // component: <DynamicExpenseSlip mode="request" />,
            component: <ExpenseSlipByRequest />,
          },


          {
            path: "dynamicSalarySlip",
            component: <PrintDynamicSalarySlipData />,
            // component: <DynamicSalarySlip mode ="monthly" />
            // component: <SavedSalarySlip />
          },

          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },

          {
            path: "educationDetailss/:email/",
            component: <PersonaldetailsEducationdetails />,
          },

          {
            path: "workexperiencee/:email/",
            component: <Personaldetailsworkexprience />,
          },

          {
            path: "emergencycontacts/:email/",
            component: <PersonaldetailsEmergencycontactdetails />,
          },

          // {
          //   path: "accountdetailss/:email/",
          //   component: <PersonaldetailsAccountdetails />,
          // },

          {
            path: "documentdetailss/:email/",
            component: <PersonaldetailsDocumentdetails />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "helpDesk",
            component: <HelpDeskDisplay />
          },

          // {
          //   path: "projectDetails",
          //   component: <ProjectDetailsManagement />
          // },
        ],
        path: "hr",
        component: <HrDashboardd />,
      },
    ],
  },

  {
    role: "Admin",
    isProtected: true,
    defaultRoute: "admin/adminDashboard",
    nestedRoutes: [
      {
        routes: [
          {
            path: "",
            component: <AdminDashboard />,
          },
          {
            path: "adminDashboard",
            component: <AdminDashboard />,
          },
          {
            path: "adminMenu",
            component: <AdminMenu />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "attendanceAndRequest",
            component: <AttendanceAndSelfRequestManagement />,
          },
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "criticalIssues",
            component: <CriticalTaskManagement />,
          },
          {
            path: "teamRequestManagement",
            component: <TeamRequestsManagementTab />,
          },
          {
            path: "hrRequestManagement",
            component: <HRRequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "dynamicRequestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "wfm",
            component: <Workforcemangement />,
          },
          {
            path: "career",
            component: <Career />,
          },
          {
            path: "setting",
            component: <SettingsManagementDisplay />,
          },
          {
            path: "hractivities",
            component: <HRActivitiesManagement />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "performancemanagement",
            component: <PerformanceManagement />,
          },
          {
            path: "payrollmanagement",
            component: <PayrollManagement />,
          },
          {
            path: "stationaryManagement",
            component: <StationaryManagement />,
          },
          {
            path: "websiteManagement",
            component: <WebsiteManagement />,
          },

          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },
          {
            path: "ProjectContractorDetails",
            component: <ProjectContractorDetails />,
          },
          {
            path: "ProjectConsultantDetails",
            component: <ProjectConsultantDetails />,
          },

          {
            path: "SiteProjectBillDetails",
            component: <SiteProjectBillDetails />,
          },

          {
            path: "userdetailscrud/:emp_code/:email/",
            component: <Userdetailscrud />,
          },
          {
            path: "hrDashboard/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetail/letterhead",
            component: <Letter />,
          },
          {
            path: "wfm/letterhead",
            component: <Letter />,
          },
          {
            path: "userdetailscrud/:emp_code/:email/letterhead",
            component: <Letter />,
          },
          {
            path: "letterhead",
            component: <Letter />,
          },

          {
            path: "dynamicSalarySlip",
            component: <PrintDynamicSalarySlipData />,
            // component: <DynamicSalarySlip mode ="monthly" />
            // component: <SavedSalarySlip />
          },
          {
            path: "upcomingSalarySlip",
            component: <PrintDynamicUpcomingSalarySlip />,
            // component: <CurrentSalarySlip />
            // component: <DynamicSalarySlip mode ="upcoming" />
          },

          {
            path: "expenseSlip",
            // component: <DynamicExpenseSlip mode="expense" />,
            component: <ExpenseSlipByExpense />,
            // component: <ExpenseSlip />
          },
          {
            path: "requestExpenseSlip/:id/",
            // component: <DynamicExpenseSlip mode="request" />,
            // component: <ExpenseSlipByRequest />,
            component: <ExpenseSlipByRequest />
          },

          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "educationDetailss/:email/",
            component: <PersonaldetailsEducationdetails />,
          },
          {
            path: "workexperiencee/:email/",
            component: <Personaldetailsworkexprience />,
          },
          {
            path: "emergencycontacts/:email/",
            component: <PersonaldetailsEmergencycontactdetails />,
          },
          // {
          //   path: "accountdetailss/:email/",
          //   component: <PersonaldetailsAccountdetails />,
          // },
          {
            path: "documentdetailss/:email/",
            component: <PersonaldetailsDocumentdetails />,
          },

          {
            path: "customReports",
            component: <ReportsManagement />
          },

          {
            path: "meetingschdeule",
            component: <CalenderContextprovider />
          },
     
          {
            path: "projectDetails",
            component: <ProjectDetailsManagement />
          },
          {
            path: "helpDesk",
            component: <HelpDeskDisplay />
          },
        ],
        path: "admin",
        component: <AdminDashboardd />,
      },
    ],
  },
];

// nestedRoutes: {
//   path: "",
//   component: "",
//   routes: [{
//     path: "",
//     component:"",
//   }],
//   nestedRoutes: [{}]
// }
